export const FilterFacilities = (allFacilities, filterSelection) => {
    const LOCATION_FILTERS = ["Indoor", "Outdoor"];
    const FACILITY_FILTERS = ["Heated", "MaxVehicleHeight"];
    const STP_FILTERS = ["disabled", "electricChargingPoint"];

    const commonFilters = [];
    const facilityFilters = [];
    const stpFilters = [];

    Object.entries(filterSelection).forEach(([key, value]) => {
        if (!value) return;

        if (LOCATION_FILTERS.includes(key)) {
            commonFilters.push(key);
        } else if (FACILITY_FILTERS.includes(key)) {
            facilityFilters.push(key);
        } else if (STP_FILTERS.includes(key)) {
            stpFilters.push(key);
        }
    });

    const ltpProductFilters = Object.entries(
        filterSelection.ParkingSpaceTypeSelection || {},
    )
        .filter(([_, v]) => v)
        .map(([k]) => k);

    return allFacilities.filter((facility) => {
        const services = (facility.Services || []).map((s) =>
            s?.toString().trim().toLowerCase(),
        );

        const facilityInfo = {
            Indoor: facility.Indoor,
            Outdoor: !facility.Indoor,
            Heated: facility.Heated ?? facility.Info?.Heated ?? false,
            MaxVehicleHeight:
                (facility.MaxVehicleHeight ??
                    facility.Info?.MaxVehicleHeight ??
                    0) > 200,
            disabled: services.includes("disabled"),
            electricChargingPoint: services.includes("electricchargingpoint"), //keep it in lowercases because the Services are normalized that way
            ...Object.fromEntries(
                facility.ParkingZones.flatMap((z) => z.Pmcs || [])
                    .filter((p) => p.ParkingSpaceType)
                    .map((p) => [p.ParkingSpaceType, true]),
            ),
        };
        const locationOk =
            commonFilters.length === 0 ||
            commonFilters.every((f) => facilityInfo[f]);

        const facilityOk =
            facilityFilters.length === 0 ||
            facilityFilters.every((f) => facilityInfo[f]);

        // No LTP/STP filter selected → show all facilities
        if (!filterSelection.LTP && !filterSelection.STP) {
            return locationOk && facilityOk;
        }

        // =========================
        // STP FLOW
        // =========================
        let stpMatch = false;

        if (filterSelection.STP && facility.HasStp) {
            const stpSpecificOk =
                stpFilters.length === 0 ||
                stpFilters.every((f) => facilityInfo[f]);

            stpMatch = locationOk && facilityOk && stpSpecificOk;
        }

        // =========================
        // LTP FLOW
        // =========================
        let ltpMatch = false;

        if (filterSelection.LTP) {
            // check for actual LTP products, including locked
            const hasActualLtpProducts =
                facility.HasLtp ||
                facility.ParkingZones?.some((zone) =>
                    (zone.Pmcs || []).some(
                        (p) =>
                            p.Visibility === "PUBLIC" ||
                            p.Visibility === "LOCKED",
                    ),
                );

            const ltpSpecificOk =
                ltpProductFilters.length === 0
                    ? true
                    : ltpProductFilters.every((f) => facilityInfo[f]);

            ltpMatch =
                hasActualLtpProducts &&
                locationOk &&
                facilityOk &&
                ltpSpecificOk;
        }

        return stpMatch || ltpMatch;
    });
};
